@if (!submitError) {
  @if (!updateConfirmed) {
    <div class="td-wb-w8ben-form-review">
      <div class="td-wb-w8ben-form-review__content">
        <h2><span [attr.id]="getModalId()"
                  translate="tdWb.w8BenForm.modal.review.TITLE"></span></h2>
        <div><span [innerHTML]="'tdWb.w8BenForm.modal.review.TITLE_TEXT' | tdWbTranslate"></span></div>
        <iframe class="td-wb-w8ben-form-review__form"
                name="td-wb-w8ben-form-review-iframe"
                [src]="w8benFormBase64"
                [title]="'tdWb.w8BenForm.modal.review.TITLE' | tdWbTranslate"></iframe>
        <div class="td-wb-w8ben-form-review__certify">
          <div class="td-wb-w8ben-form-review__certify-title">
            <span translate="tdWb.w8BenForm.modal.review.CERTIFICATION_TITLE"></span>
          </div>
          <div class="td-wb-w8ben-form-review__certify-text">
            <span translate="tdWb.w8BenForm.modal.review.CERTIFICATION_TEXT"></span>
          </div>
          <div class="td-wb-w8ben-form-review__certify-action">
            <td-wb-checkbox class="td-wb-w8ben-form-review__certify-action-checkbox"
                            [(ngModel)]="certified">
              <b><span translate="tdWb.w8BenForm.modal.review.CERTIFICATION_CHECKBOX_TITLE"></span></b>
            </td-wb-checkbox>
            <div class="td-wb-w8ben-form-review__certify-action-description">
              <span translate="tdWb.w8BenForm.modal.review.CERTIFICATION_CHECKBOX_TEXT"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="td-wb-w8ben-form-review__actions">
        <td-wb-divider class="td-wb-w8ben-form-review__divider" />
        <td-wb-page-action-panel position="end"
                                [top]="true"
                                [bottom]="false"
                                [left]="false"
                                [right]="false">
          <button id="td-wb-w8ben-form-review-back"
                  tdWbButton
                  tdWbButtonType="secondary"
                  [tdWbHref]="'modal.w8ben.' + (hasUpdates ? 'tax_residency_benefits' : 'us_tin')"
                  [tdWbHrefParams]="{ hasUpdates: hasUpdates }">
            <span translate="tdWb.w8BenForm.modal.review.BACK"></span>
          </button>
          <button id="td-wb-w8ben-form-review-confirm"
                  tdWbButton
                  tdWbButtonType="primary"
                  [disabled]="!certified"
                  (click)="onClickConfirm()">
            <span translate="tdWb.w8BenForm.modal.review.CONFIRM"></span>
          </button>
        </td-wb-page-action-panel>
      </div>
    </div>
  } @else {
    <td-wb-w8ben-success-message>
      <div class="td-wb-w8ben-form-review__success-message">
        <span [attr.id]="getModalId()"
              translate="tdWb.w8BenForm.modal.review.SUCCESS_MESSAGE_DESCRIPTION"></span>
      </div>
      <div class="td-wb-w8ben-form-review__success-message-link">
        <a id="td-wb-w8ben-form-review-success-message-link"
          [href]="w8benFormBase64"
          [download]="getFileName()"
          (click)="onClickDownload()">
          <td-wb-icon iconId="download--small"
                      size="14" />
        <span translate="tdWb.w8BenForm.modal.review.SUCCESS_MESSAGE_LINK"></span>
      </a>
      </div>
    </td-wb-w8ben-success-message>
  }
} @else {
  <td-wb-w8ben-form-error [submitError]="true" />
}
